import axios from "axios";
import store from "../store/store";
import { LOGOUT_USER } from "../actions/auth-actions/types";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

axiosInstance.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error && error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          // reconnect
          //  store.dispatch({
          //   type: LOGOUT_USER,
          //  });
          break;
        default:
          break;
      }
    }
    // do something with response error
    return Promise.reject(error);
  }
);

export default axiosInstance;
